/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext } from "react";
import {
  Button,
  Form,
  Card,
  Badge,
} from "@themesberg/react-bootstrap";
import { useState } from "react";
import { useCallback } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useEffect } from "react";
import { postApi } from "../../../redux/api";
import CustomTable from "../../../components/CustomTable";
import { toast } from 'react-hot-toast';
import SearchInput from "../../../components/SearchInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faPrint,
  faSync,
} from "@fortawesome/free-solid-svg-icons";
import { Routes } from "../../../routes";
import { formatNumber } from "../../../redux/utils";
import { SearchContext } from "../../HomePage";
import { useSelector } from "react-redux";
import { Col, Row } from "react-bootstrap";
import moment from "moment-timezone";
import { useResponsive } from "../../../hooks/useResponsive";
import ResponsiveContainer from "../../../components/ResponsiveContainer";
import ReleasePrintPreviewModal from "./ReleasePrintPreviewModal";

function MDARelease({ match, type = null }) {
  const { isMobile } = useResponsive();
  const user = useSelector((state) => state.auth.user);
  const history = useNavigate();
  const location = useLocation();
  const { searchTerm, setSearchTerm } = useContext(SearchContext);
  const [filterText, setFilterText] = useState("");
  const [budgetUtilization, setBudgetUtilization] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dateFrom, setDateFrom] = useState(moment().subtract(1, 'month').format('YYYY-MM-DD'));
  const [dateTo, setDateTo] = useState(moment().format('YYYY-MM-DD'));
  const [selectedApprovals, setSelectedApprovals] = useState(new Set());
  const [showPrintPreview, setShowPrintPreview] = useState(false);

  const getMDAReleasesCollection = useCallback(() => {
    setLoading(true);

    postApi(`post-cc?query_type=select_mda`, {
      mda_name: user?.mda_name
    }).then((data) => {
      if(data && data.results) {
        const officeName = data.results[0]?.officeTitle
;
        postApi(`post_approval_collection`, {
          form: { 
            query_type: "by_cc", 
            cc: officeName,
            mda_code: user?.mda_code || "" 
          },
        })
          .then((data) => {
            if (data.result) {
              const arr = [];
              data.result.forEach((item) => {
                arr.push({ ...item, isOpen: false });
              });
              setBudgetUtilization(data.result);
            }
          })
          .catch((err) => {
            toast.error(err);
          })
          .finally(() => {
            setLoading(false);
          });
          }
        })
    
  }, [user?.mda_name]);

  useEffect(() => {
    getMDAReleasesCollection();
  }, [getMDAReleasesCollection]);

  const handleFilter = () => {
    const filteredList = budgetUtilization.filter((item) => {
      const dateFromCondition = dateFrom ? new Date(item.collection_date) >= new Date(dateFrom) : true;
      const dateToCondition = dateTo ? new Date(item.collection_date) <= new Date(dateTo) : true;
      return dateFromCondition && dateToCondition;
    });
    return filteredList;
  };

  useEffect(() => {
    handleFilter();
  }, [dateFrom, dateTo]);

  const filteredList = handleFilter();

  let list = [];
  filteredList.forEach((item) => {
    const approvalNo = item.full_approval_no || item.approval_no || "";
    if (
      filterText &&
      !approvalNo.toLowerCase().includes(filterText.toLowerCase())
    )
      return;
    else list.push(item);
  });

  const finalList = [];
  list.forEach((item) => {
    const approvalNo = item.full_approval_no || item.approval_no || "";
    if (searchTerm && !approvalNo.toLowerCase().includes(searchTerm.toLowerCase()))
      return;
    finalList.push(item);
  });

  const toggleSelect = (approvalNo) => {
    const next = new Set(selectedApprovals);
    if (next.has(approvalNo)) next.delete(approvalNo);
    else next.add(approvalNo);
    setSelectedApprovals(next);
  };

  const selectAll = () => {
    if (selectedApprovals.size === finalList.length && finalList.length > 0) {
      setSelectedApprovals(new Set());
    } else {
      setSelectedApprovals(new Set(finalList.map((item) => item.full_approval_no || item.approval_no)));
    }
  };

  const fields = [
    {
      title: (
        <Form.Check
          type="checkbox"
          onChange={selectAll}
          checked={selectedApprovals.size === finalList.length && finalList.length > 0}
        />
      ),
      custom: true,
      component: (item, index) => {
        const approvalNo = item.full_approval_no || item.approval_no;
        return (
          <div className="d-flex align-items-center gap-2">
            <Form.Check
              type="checkbox"
              checked={selectedApprovals.has(approvalNo)}
              onChange={() => toggleSelect(approvalNo)}
            />
            <Button
              size="sm"
              variant="outline-primary"
              onClick={() => {
                const url = `${Routes.cashBacking.releaseCollectionHTML}?approval_no=${encodeURIComponent(approvalNo)}&from=cc`;
                history(url);
              }}
            >
              <FontAwesomeIcon icon={faEye} className="me-1" />
              View
            </Button>
          </div>
        );
      },
    },
    {
      title: "Approval Date",
      value: "approval_date",
    },
    {
      title: "Approval No",
      value: "full_approval_no",
    },
    {
      title: "Narration",
      value: "narration",
    },
    {
      title: "Amount",
      custom: true,
      component: (item) => (
        <div className="text-end">{formatNumber(item.amount)}</div>
      ),
    },
  ];

  const getRowStyle = (row) => {
    if (row?.approval_status?.includes("Return")) {
      return { backgroundColor: "orange" };
    } else {
      return {}
    }
  };

  useEffect(() => {
    return () => {
      setSearchTerm("");
    };
  }, [setSearchTerm]);

  const selectedApprovalNos = Array.from(selectedApprovals);

  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <h4>
            CC Copies
          </h4>
          <p className="text-muted">Releases where your MDA is copied (CC)</p>
        </div>
        <div className="d-flex gap-2">
          <Button
            variant="success"
            size="sm"
            disabled={selectedApprovals.size === 0}
            onClick={() => setShowPrintPreview(true)}
          >
            <FontAwesomeIcon icon={faPrint} className="me-1" />
            Print Preview{selectedApprovals.size > 0 ? ` (${selectedApprovals.size})` : ""}
          </Button>
          <Button variant="outline-primary" size="sm" onClick={getMDAReleasesCollection}>
            <FontAwesomeIcon icon={faSync} className="me-1" />
            Refresh
          </Button>
        </div>
      </div>
      <Row>
        <Col md={6} style={{
          marginTop: 28
        }}>
          <SearchInput
            placeholder="Search For MDA Releases"
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
          />
        </Col>
        <Col md={6}>
          <Row style={{
            marginBottom: 10
          }}>
            <Col md={6}>
              <Form.Group id="date_from">
                <Form.Label>Date From</Form.Label>
                <Form.Control
                  type="date"
                  value={dateFrom}
                  onChange={(e) => setDateFrom(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group id="date_to">
                <Form.Label>Date to</Form.Label>
                <Form.Control
                  type="date"
                  value={dateTo}
                  onChange={(e) => setDateTo(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
        </Col>
      </Row>

      <Card border="light" className="table-wrapper table-responsive shadow-sm">
        <Card.Body className="p-0">
          {loading ? (
            <div className="d-flex justify-content-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <div className={isMobile ? "" : "table-container"} style={{ height: isMobile ? "auto" : "80vh", overflow: isMobile ? "visible" : "scroll" }}>
              {isMobile ? (
                <div className="mobile-cards-container">
                  {finalList.map((item, index) => {
                    const approvalNo = item.full_approval_no || item.approval_no;
                    return (
                      <Card key={index} className="mb-2 shadow-sm">
                        <Card.Body className="p-3">
                          <div className="d-flex align-items-center justify-content-between mb-2">
                            <Form.Check
                              type="checkbox"
                              checked={selectedApprovals.has(approvalNo)}
                              onChange={() => toggleSelect(approvalNo)}
                              label={<strong>{item.full_approval_no || item.approval_no}</strong>}
                            />
                            <Badge bg={item.approval_status?.includes("Return") ? "warning" : "info"}>
                              {item.approval_status}
                            </Badge>
                          </div>
                          <div className="small text-muted mb-2">
                            <div>Date: {item.approval_date}</div>
                            <div>Narration: {item.narration || "-"}</div>
                          </div>
                          <div className="d-flex justify-content-between align-items-center">
                            <strong className="text-primary">{formatNumber(item.amount)}</strong>
                            <Button
                              size="sm"
                              variant="outline-primary"
                              onClick={() => {
                                const url = `${Routes.cashBacking.releaseCollectionHTML}?approval_no=${encodeURIComponent(approvalNo)}`;
                                history(url);
                              }}
                            >
                              <FontAwesomeIcon icon={faEye} className="me-1" />
                              View
                            </Button>
                          </div>
                        </Card.Body>
                      </Card>
                    );
                  })}
                </div>
              ) : (
                <CustomTable
                  fields={fields}
                  data={finalList}
                  getRowStyle={(data) => getRowStyle(data)}
                />
              )}
            </div>
          )}
        </Card.Body>
      </Card>

      <ReleasePrintPreviewModal
        show={showPrintPreview}
        onHide={() => setShowPrintPreview(false)}
        approvalNos={selectedApprovalNos}
      />
    </>
  );
}

export default MDARelease;
